import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function DemoPopup({
    open = false,
    handleClose = () => {},
    handleConfirm = () => {},
}) {
    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle id="alert-dialog-title">{'Open Winner demo page'}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    Go to winner demo page
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button onClick={handleConfirm} autoFocus>
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    );
}
